import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import TokenDetail from "@/pages/TokenDetail";

export const Route = createFileRoute("/_app/markets/$id")({
  component: () => (
    <PageGate pageKey="tokens"><TokenDetail /></PageGate>
  ),
});
